<template>
    <div class="active-filters">
        <span clasS="active-filters__label" v-html="$t('OrganizationReport.active_filters')"></span>
        <span v-for="(value, name, index) in activeFilters" :key="index" class="active-filters__filter">
            <span class="active-filters__filter-name">{{ name }}:</span>
            <span class="active-filters__filter-value" v-for="(item, index) in value" :key="index">{{ item.label }}</span>
        </span>
    </div>
</template>

<script>
    import { translateWithDefault } from 'helpers/i18nHelper'
    import moment from 'moment'

    export default {
        name: 'active-filters',
        props: {
            filters: {
                type: Object
            },
            filterStaticData: {
                type: Object
            }
        },
        computed: {
            activeFilters () {
                const activeFilters = {}
                const sortedActiveFilters = {}
                const objKeys = ['startDate', 'endDate']

                Object.keys(this.filters).forEach(filterKey => {
                    if (!this.filters[filterKey].length) {
                        return
                    }

                    if (!objKeys.includes(filterKey)) {
                        let key = this.$t(this.filterStaticData[filterKey].translationString)
                        activeFilters[key] = this.filters[filterKey].map(el => {
                            return {
                                value: el.value,
                                label: translateWithDefault(el.label, el.label),
                                order: this.filterStaticData[filterKey].order
                            }
                        })
                    }
                })

                const startDate = moment(this.filters['startDate'][0].label).format('DD.MM.YYYY')
                const endDate = moment(this.filters['endDate'][0].label).format('DD.MM.YYYY')
                const datesKey = this.$t('ReportingFilters.dates')

                activeFilters[datesKey] = [{
                    label: startDate + ' - ' + endDate,
                    order: 1
                }]

                Object.keys(activeFilters)
                    .sort((a,b) => activeFilters[a][0].order - activeFilters[b][0].order)
                    .forEach((key) => sortedActiveFilters[key] = activeFilters[key])

                return sortedActiveFilters
            }
        }
    }
</script>

<style lang="scss" scoped>
    .active-filters {
        gap: 10px;
        align-items: center;
        background: $wild_sand;
        font-family: PlusJakartaSans-Regular, sans-serif;
        padding: 10px;
        font-size: 1.6rem;
        border-radius: 7px;
        margin: 15px 0 20px 0;
        display: flex;

        &__filter {
            background: $light_blue;
            border: 1px solid $bright_lavender;
            color: $black;
            font-size: 1.3rem;
            border-radius: 16px;
            padding: 3px 12px;
            min-height: 26px;
            display: flex;
            align-items: center;
        }

        &__filter-name {
            font-family: PlusJakartaSans-Bold, sans-serif;
            margin: 0 3px 0 0;
        }

        &__filter-value {
            margin: 0 3px 0 0;

            &:after {
                content: ',';
            }
            &:last-of-type {
                &:after {
                    content: '';
                }
            }
        }
    }
</style>
